<script setup lang="ts">
import { PhCheckCircle as CheckCircle, PhSpinnerGap as SpinnerGap } from "@phosphor-icons/vue";
import { onMounted, onUnmounted, ref } from "vue";
import BrandBar from "./BrandBar.vue";
import { useSessionStore } from "../stores/session";

const store = useSessionStore();
const phase = ref(-1);

const timers: number[] = [];

onMounted(() => {
  timers.push(window.setTimeout(() => phase.value = 0, 220));
  timers.push(window.setTimeout(() => phase.value = 1, 620));
  timers.push(window.setTimeout(() => phase.value = 2, 1020));
  timers.push(window.setTimeout(() => store.revealResult(), 1600));
});

onUnmounted(() => timers.forEach(window.clearTimeout));
</script>

<template>
  <section class="screen screen--loading">
    <BrandBar />
    <div class="loading-orbit"><SpinnerGap :size="42" weight="bold" /></div>
    <p class="eyebrow">NBTI 正在读取你的工位气场</p>
    <h1>正在计算你的<br />牛马体质成分</h1>
    <div class="loading-checks">
      <p :class="{ done: phase >= 0 }"><CheckCircle :size="20" weight="fill" /> 汇总 4 项职场维度</p>
      <p :class="{ done: phase >= 1 }"><CheckCircle :size="20" weight="fill" /> 匹配 9 种牛马人格</p>
      <p :class="{ done: phase >= 2 }"><CheckCircle :size="20" weight="fill" /> 生成你的班味身份证</p>
    </div>
  </section>
</template>
